import React from 'react'
import { Product as ModelProduct } from '../../Models/Product'
import { Feature } from '../../Models/Feature'
import FeatureProduct from './FeatureProduct'

import { motion, MotionProps } from 'framer-motion';

//styles
import "./Product.css"

interface Props{
    product:ModelProduct
    delay:number
}

const Product = ({product, delay}:Props) => {

      const getFadeUpAnimation = (index = 0): MotionProps => ({
        initial: { opacity: 0, y: -50 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, margin: "0px" },
        transition: {
            duration: 0.5,
            ease: "easeOut",
            delay: index * 0.3,
        },
        });

  return (
    <motion.div className='product-item' {...getFadeUpAnimation(delay)}>
        <div className='product-item-header'>
            <img src={product.img}></img>
        </div>

        <div className='product-item-content'>
            <h3>{product.name}</h3>
            <span>{product.description}</span>

            <div className='product-item-features'>
                {product.features.map((f:Feature)=>{
                    return <FeatureProduct feature={f} key={"feature "+ f.id} />
                })}
            </div>
        </div>
    </motion.div>
  )
}

export default Product